import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-load-watch-performance-all',
  templateUrl: './load-watch-performance-all.component.html',
  styleUrls: ['./load-watch-performance-all.component.css']
})
export class LoadWatchPerformanceAllComponent implements OnInit {
  reportPerformance: any;
  searchList: any;
  totalRunTimeSec: number = 0;
  totalLoadedRunTimeSec: number = 0;
  totalIdleRunTimeSec: number = 0;
  totalOverloadDurationSec: number = 0;
  totalRunCount: number = 0;
  totalFuelConsumed: number = 0;
  totalEnergyProduced: number = 0;
  strTotalRunTimeSec: string = '';
  strTotalLoadedRunTimeSec: string = '';
  strTotalIdleRunTimeSec: string = '';
  strTotalOverloadDurationSec: string = '';

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strSDate: new FormControl(momentJalaali().subtract(30, 'day').format('jYYYY/jMM/jDD')),
    strEDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
  }

  fetchData = async () => {
    let model = this.searchForm.value;

    this._other.Showspinner()
    let res = JSON.parse((await axios.post(`LoadWatch_DailyReport_Performance_All`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.reportPerformance = this.searchList = res;
    this.calculateTotals();

  }

  calculateTotals() {
    this.totalRunTimeSec = 0;
    this.totalLoadedRunTimeSec = 0;
    this.totalIdleRunTimeSec = 0;
    this.totalOverloadDurationSec = 0;
    this.totalRunCount = 0;
    this.totalFuelConsumed = 0;
    this.totalEnergyProduced = 0;

    for (const item of this.reportPerformance) {
      this.totalRunTimeSec += parseInt(item.iRunTimeSec ?? 0);
      this.totalLoadedRunTimeSec += parseInt(item.iLoadedRunTimeSec ?? 0);
      this.totalIdleRunTimeSec += parseInt(item.iIdleRunTimeSec ?? 0);
      this.totalOverloadDurationSec += parseInt(item.iOverloadDurationSec ?? 0);
      this.totalRunCount += parseInt(item.iRunCount ?? 0);
      this.totalFuelConsumed += parseFloat(item.fFuelConsumed ?? 0);
      this.totalEnergyProduced += parseFloat(item.fEnergyProduced ?? 0);
    }

    this.totalFuelConsumed = Number(this.totalFuelConsumed.toFixed(2));
    this.totalEnergyProduced = Number(this.totalEnergyProduced.toFixed(2));

    this.strTotalRunTimeSec = this.secondsToHMS(this.totalRunTimeSec);
    this.strTotalLoadedRunTimeSec = this.secondsToHMS(this.totalLoadedRunTimeSec);
    this.strTotalIdleRunTimeSec = this.secondsToHMS(this.totalIdleRunTimeSec);
    this.strTotalOverloadDurationSec = this.secondsToHMS(this.totalOverloadDurationSec);
  }

  secondsToHMS(totalSeconds: any) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  filterList(val: any) {
    // this.loadwatches = this.searchList.filter((el: any) => {
    //   return el.iLoadWatch.toString().includes(val.value) ||
    //     el.fRatedPowerKW.toString().includes(val.value) ||
    //     el.strName.includes(val.value) ||
    //     el.strModel.includes(val.value) ||
    //     el.strBrand.includes(val.value)
    // });

    // if (val.value.length == 0) {
    //   this.loadwatches = this.searchList;
    // }
  }

  exportExcel(): void {
    let element = document.getElementById("Export_Excel");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'عملکرد ژنراتور.xlsx');
  }

}
